
import { Injectable } from '@angular/core';
import { waitMinutes, waitSeconds } from '@reflact/tsutil';
import { BehaviorSubject, Subject } from 'rxjs';
import { EventManagerAdminService } from './event-manager/event-manager-admin.service';
import { ScoreService } from './score/score.service';
import { ScormManagerService } from './scorm-manager.service';

@Injectable({
  providedIn: 'root'
})
export class WaitForManagerService {

  public wasInitialIdle: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public nextIdleSubject: Subject<boolean> = new Subject<boolean>();

  public seconds = waitSeconds;
  public minutes = waitMinutes;


  constructor(
    public eventManager: EventManagerAdminService,
    public score: ScoreService,
    public scormManager: ScormManagerService,
    public eventManagerService: EventManagerAdminService
  ) { }


  public secondsAndExec(seconds: number, fn: () => unknown) {
    this.seconds(seconds).then(() => { fn(); }).catch((e: unknown) => { console.log("Error secondsAndExec fn ", e); });

  }
  public minutesAndExec(minutes: number, fn: () => unknown) {
    this.minutes(minutes).then(() => { fn(); }).catch((e: unknown) => { console.log("Error minutesAndExec fn ", e); });
  }

  public _nextIdleReached() {
    this.nextIdleSubject.next(true);
  }
  public _initialIdleReached() {
    if (!this.wasInitialIdle.getValue()) {
      this.wasInitialIdle.next(true);
      this.eventManager._trigger_RAGAI_EVENT("EVENT.initialidle", null);
    }
  }

  public event(hook: string) {
    const hookId = `RAGAI.WAITFOR.event-${hook}-${crypto.randomUUID()}`;
    return new Promise((resolve) => {
      this.eventManager.on(hook, (params) => {
        this.eventManager.off(hookId);
        resolve(params);
      }, hookId);
    });
  }


  public nextIdle() {
    return new Promise((resolve) => {
      this.nextIdleSubject.subscribe((v) => {
        if (v) {
          resolve(null);
        }
      });
    });
  }

  public scormInited() {
    console.log("scorm inited done");
    const isInLMS = this.scormManager.runsInLms();
    // NICHTIN LMS
    if (!isInLMS) {
      return new Promise((resolve) => {
        console.log("not in LMS - resolve scormInited");
        resolve(null);
      });
    }

    /// IM LMS UND BEREITS DURHCC
    if (!this.scormManager.isFakeScorm()) {
      return new Promise((resolve) => {
        console.log("in LMS - and real scorm ");
        resolve(null);
      });
    }
    // IM LMS UND NOCH NICHT DURCH

    return new Promise((resolve) => {
      console.log("in LMS - wait for scorm inited");
      this.eventManagerService.on("RAGAI.SCORM.INITED", () => {
        console.log("scorm inited event received ");
        resolve(null);
      });
    });
  }











  public initialIdle() {


    console.log("return initianIdlePromise");
    return new Promise((resolve) => {
      if (this.wasInitialIdle.getValue()) {
        console.log("War schon idle");
        resolve(null);
        return;
      }
      this.wasInitialIdle.subscribe((v) => {
        //console.log("Bin jetzt idle schon idle");
        if (v) {
          resolve(null);
        }
      });
    });
  }

  public varsInit() {
    return this.score.waitForInitials();
  }
}
